import { AfterViewInit, Component, OnInit, ViewChild, NgZone, ElementRef, VERSION, Inject, Input, HostListener } from '@angular/core';
import { FormControl, FormGroup, FormArray, ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, NG_VALIDATORS, Validators, Validator, NgForm } from '@angular/forms';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject ,  Subscription } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { DOCUMENT } from '@angular/common';
import { CustomValidators } from '../../directives/custom-validator.directive';
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { formService } from "../../services/form.service";
import { packageLookup } from '../../models/packageLookup';
import { formDialogService } from '../../services/formDialogService';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';






class packages {
  code: number;
  length: number;
  width: number;
  height: number;
  weight: number;
}

@Component({
  selector: 'app-package-info',
  templateUrl: './package-info.component.html',
  styleUrls: ['./package-info.component.scss']
})
export class PackageInfoComponent implements OnInit {
  saas_token=environment.excel_upload_saas;
  AdminDisableBtn: boolean;
  supplierNameJP: any;
  copiedPartInfo: { currentPart: any; copyPart: any; partInfoSave: any; supplyInfoSave: number; pkgInfoSave: any; };
  partDataFor: any;
  disableSubmit: boolean;
  adminAccess: any;
  loggedInUser: any;
  imgToDelete: any;
  masterDataSheet: any;
  pkgImageDetails: any;
  fusoPkgByIdData: any;
  isLoading=true;
  fusoPkgselect: any;
  fusoPackageLookup: any;
  suppTabActive: boolean = true;
  showFusoPkg: any;
  repackagingOption: any;
  revisedCommentError: boolean;
  revisedComment: any;
  showRevisedSubmit: boolean;
  displayOverallStatus: string;
  overAllPackageIDStatus: any;
  pkgByIdData: any;
  navigateAfterSave: boolean = true;
  userRoleName: any;
  updateStatusTo: any;
  statusOption: any;
  loginId: any;
  showStatusError: boolean;
  statusComment: any;
  userRoleId: any;
  partLSData: any;
  closeResult: string;
  pkgselect: any;
  packageLookupSel: any;
  packageInfoResult: any;

  globalInfoData: any = null;
  packageInfoData: any = null;

  @Input() partInfoForm: FormGroup;

  specialPackageOpt: string[] = ["Yes", "No"];
  fuso_specializedPackageOpt: string[] = ["Yes", "No"];
  returnableOpt: string[] = ["Yes", "No"];
  fuso_returnableOpt: string[] = ["Yes", "No"];
  stackableOpt: string[] = ["Yes", "No"];
  fuso_stackableOpt: string[] = ["Yes", "No"];
  rustOpt: string[] = ["Yes", "No", "N/A"];
  inter: string = "Yes";
  interferenceOpt: string[] = ["Yes", "No", "N/A"];
  Clean: string = "Yes";
  cleanlinessOpt: string[] = ["Yes", "No", "N/A"];

  containerTypeOpt: string[] = ["Yes", "No"];
  repackingOpt: string[] = ["Yes", "No"];
  packagingPropertyOpt: string[] = ["Fuso(ふそう)", "Supplier(御社)"];
  standardPackageOpt: string[] = ["Yes", "No"];
  fuso_standardPackageOpt: string[] = ["Yes", "No"];
  partsInBoxOpt: string[] = ["Yes", "No"];
  repackagingOpt: string[] = ["Yes", "No"];

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  packageCode: packages[] = [];
  dtTrigger: Subject<any> = new Subject();
  private jsonFileURL: string = "assets/api/json/packageCode.json";
  showLookup: boolean = false;
  showRegPackage: boolean = false;

  packageInfoForm: FormGroup;

  partServData: any;
  supplyServData: any;
  subscription: Subscription;

  packageLookup: packageLookup[];
  filter: packageLookup = new packageLookup();

  partApiData: any;
  routePackageID: any;
  partData: any;
  parts: any;
  showStatusComment: boolean = false;

  cleanlinessEdit: boolean;
  interferenceEdit: boolean;
  rustEdit: boolean;
  partsPerSetEdit: boolean;
  maxBoxWeightEdit: boolean;
  maxBoxWeight: boolean;
  partsPerSet: boolean;
  setsPerPkgEdit: boolean;
  containerTypeEdit: boolean;
  maxBoxQtyEdit: boolean;
  packagingMaterialEdit: boolean;
  permittedCapacityEdit: boolean;
  tareWeightEdit: boolean;
  packGrpIdEdit: boolean;
  maxStackQtyEdit: boolean;
  stackableEdit: boolean;
  returnableEdit: boolean;
  FoldableHeightEdit: boolean;
  FoldableLengthEdit: boolean;
  FoldableWidthEdit: boolean;
  FoldableEdit: boolean;
  externalVolumeEdit: boolean;
  externalHeightEdit: boolean;
  externalLengthEdit: boolean;
  externalWidthEdit: boolean;
  innerHeightEdit: boolean;
  innerVolumeEdit: boolean;
  innerLengthEdit: boolean;
  innerWidthEdit: boolean;
  packagingNameEdit: boolean;
  packagingProperty: boolean;
  repackagingLocationEdit: boolean;
  specializedPackagingEdit: boolean;
  standardPackagingEdit: boolean;
  packagingCodeEdit: boolean;

  modelRef: NgbModalRef;

  isDuplicationMasterFilename
  isDuplicationpackageFilename
  packageID: string;
  pkgimgUploadProgress: boolean;
  masterUploadProgress: boolean;
  data: any;
  disableRevalidate:boolean;
  validate: boolean=false;
  formData: any;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any,
    private form: FormBuilder,
    private logbaseService: logbaseService,
    private dataService: dataService,
    private formService: formService,
    private formDialogService: formDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService
  ) {
    this.logbaseService.getFormData().subscribe((data)=>{
      this.formData=data;
    })
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.loggedInUser = userDetJson.loginId;

    this.adminAccess = userDetJson.userRoleMappings[0].roleId;
    this.showLookup = false;
    this.showRegPackage = false;
    this.subscription = this.dataService.getFormData().subscribe(formData => { this.partServData = formData;console.log("partServ infodata in packageinfo",this.partServData)  });
    this.subscription = this.formService.getSupplyFormData().subscribe(formData => { this.supplyServData = formData;console.log("supplier infodata in packageinfo",this.supplyServData) });

    
    
  }

  ngOnInit() {
    this.spinner.show();
    this.isLoading=true;
    this.AdminDisableBtn = false;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

    // Get package id to get all other details
    this.routePackageID = this.route.snapshot.params['id'];

    this.logbaseService.getNewPartsbyPkgId(this.routePackageID)
      .subscribe(
        result => {
          this.overAllPackageIDStatus = result.response.ovarAllPackageIDStatus;

          //Get parts data from URL and bind in form fields
          this.partData = result.response;

          // Get Package Information form data which is already saved
          this.getPackageInfoById(this.partData);

          // to disable save, next & submit button if user already preformed their corresponding actions
          this.disableCheck(this.partData);

          // To get Supplier name
          this.getSupplierName(this.partData);

          if (this.overAllPackageIDStatus == 'new') {
            this.displayOverallStatus = 'New';
            this.showRevisedSubmit = false;
          } else if (this.overAllPackageIDStatus == 'inProgress') {
            this.displayOverallStatus = 'In Progress';
            this.showRevisedSubmit = false;
          } else if (this.overAllPackageIDStatus == 'approved') {
            this.displayOverallStatus = 'Approved';
            this.showRevisedSubmit = true;
          } else if (this.overAllPackageIDStatus == 'rejected') {
            this.displayOverallStatus = 'Rejected';
            this.showRevisedSubmit = false;
          } else if (this.overAllPackageIDStatus == 'underReview') {
            this.displayOverallStatus = 'Under Review';
            this.showRevisedSubmit = false;
          } else if (this.overAllPackageIDStatus == 'approvedAndClosed') {
            this.displayOverallStatus = 'Approved & Closed';
            this.showRevisedSubmit = true;
          }
        });

    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleId = userDetJson.userRoleMappings[0].roleId;
    this.userRoleName = userDetJson.userRoleMappings[0].roleName;
    this.loginId = userDetJson.loginId;

    this.createFormControls();
    this.checkFieldAccess();

    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 15,
      scrollY: '350',
      autoWidth: true,
      dom: '<"top"p<"clear">><"#dtSearch">t<"bottom"<"clear">>',
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          //self.someClickHandler(data);
        });
        return row;
      }
    };

    // Get all package details
    this.logbaseService.getAllPackages()
      .subscribe(
        result => {
          this.packageLookup = result.response;
        });


    // Get all fuso package details
    if (this.userRoleId == 4) {
      this.logbaseService.getAllFusoPackages()
        .subscribe(
          result => {
            this.fusoPackageLookup = result.response;
            this.isLoading=false;
          });
    };

    // setTimeout(() => {
    //   this.subscription = this.dataService.getFormData().subscribe(formData => { this.partServData = formData; });
    //   this.subscription = this.formService.getSupplyFormData().subscribe(formData => { this.supplyServData = formData; });
    // }, 1000);
    
  };
  

  getSupplierName(partData) {
    // this.spinner.show();
    let suppCode = partData.supplierCode;
    this.logbaseService.fetchSupplierName(suppCode)
      .subscribe(result => {
        this.supplierNameJP = result.response.supplierNameJP;
        this.packageInfoForm.patchValue({
          supplierName: result.response.supplierNameJP
        });
        // this.spinner.hide();
      });
    
  };

  getPackageInfoById(partData) {
    

    let localPartData = localStorage.getItem("copiedPart");
    if (localPartData) {
      if (localPartData != 'undefined') {
        let copiedPart = JSON.parse(localPartData);

        if (copiedPart.currentPart == this.routePackageID) {
          if (copiedPart.pkgInfoSave == 1) {
            this.partDataFor = this.routePackageID;
          } else {
            this.partDataFor = copiedPart.copyPart;
          }
        } else {
          this.partDataFor = this.routePackageID;
        }
      } else {
        this.partDataFor = this.routePackageID;
      }
    } else {
      this.partDataFor = this.routePackageID;
    }
    // this.spinner.show();
    this.logbaseService.getPackageInfoData(this.partDataFor)
      .subscribe(
        result => {
          this.packageInfoResult = result;
          this.pkgImageDetails = this.packageInfoResult.response.imageInfos;

          // Patch the value from response to form field input
          this.packageInfoForm.patchValue({
            supplierCode: partData.supplierCode,
            partNumber: partData.partNumber,
            partName: partData.partName
          });
          // this.isLoading=false

          if (this.packageInfoResult.response.packageCode) {
            // this.spinner.show();
            this.logbaseService.getPackageById(this.packageInfoResult.response.packageCode)
              .subscribe(result => {
                this.pkgByIdData = result;
                if(this.pkgByIdData.response.standardPackaging=='Yes(はい)' || this.pkgByIdData.response.standardPackaging=='No(いいえ)'){
                  this.standardPackageOpt=["Yes(はい)", "No(いいえ)"];
                }
                if(this.pkgByIdData.response.specializedPackaging=='Yes(はい)' || this.pkgByIdData.response.specializedPackaging=='No(いいえ)'){
                  this.specialPackageOpt=["Yes(はい)", "No(いいえ)"];
                }
                this.packageInfoForm.patchValue({
                  packagingCode: this.pkgByIdData.response.packageCode,
                  //packagingCode: this.packageInfoResult.response.packageCode,
                  standardPackage: this.pkgByIdData.response.standardPackaging,
                  specializedPackage: this.pkgByIdData.response.specializedPackaging,
                  packagingName: this.pkgByIdData.response.packagingName,
                  packagingProperty: this.packageInfoResult.response.packagingProperty,
                  //totalBoxWeight: this.pkgByIdData.response.totalMaxWeightBox,
                  innerWidth: this.pkgByIdData.response.innerPackDimW,
                  innerLength: this.pkgByIdData.response.innerPackDimL,
                  innerHeight: this.pkgByIdData.response.innerPackDimH,
                  innerVolume: this.pkgByIdData.response.innerVolume,
                  externalWidth: this.pkgByIdData.response.externalPackDimW,
                  externalLength: this.pkgByIdData.response.externalPackDimL,
                  externalHeight: this.pkgByIdData.response.externalPackDimH,
                  cubicMeter: this.pkgByIdData.response.externalCubicMeter,
                  isFoldable: this.pkgByIdData.response.isFoldable,
                  foldableWidth: this.pkgByIdData.response.foldablePackDimW,
                  foldableLength: this.pkgByIdData.response.foldablePackDimL,
                  foldableHeight: this.pkgByIdData.response.foldablePackDimH,
                  foldableVolume: this.pkgByIdData.response.foldableVolume,
                  tareWeight: this.pkgByIdData.response.packageTareWeight,
                  loadCapacity: this.pkgByIdData.response.permittedLoadCapacity,
                  packageMaterial: this.pkgByIdData.response.packageMaterial,
                  containerType: this.pkgByIdData.response.containerType
                });

               // this.spinner.hide();
                this.isLoading=false;
               
              });
          }

          if (this.packageInfoResult.response.fusoPackageCode) {
            // this.spinner.show();
            this.logbaseService.getFusoPackageById(this.packageInfoResult.response.fusoPackageCode)
              .subscribe(result => {
                this.fusoPkgByIdData = result;
                this.packageInfoForm.patchValue({
                  fuso_packagingCode: this.fusoPkgByIdData.response.fusoPackageCode,
                  fuso_standardPackage: this.fusoPkgByIdData.response.standardPackaging,
                  fuso_specializedPackage: this.fusoPkgByIdData.response.specializedPackaging,
                  fuso_packagingName: this.fusoPkgByIdData.response.packagingName,
                  fuso_totalBoxWeight: this.fusoPkgByIdData.response.totalMaxWeightBox,
                  fuso_innerWidth: this.fusoPkgByIdData.response.innerPackDimW,
                  fuso_innerLength: this.fusoPkgByIdData.response.innerPackDimL,
                  fuso_innerHeight: this.fusoPkgByIdData.response.innerPackDimH,
                  fuso_innerVolume: this.fusoPkgByIdData.response.innerVolume,
                  fuso_externalWidth: this.fusoPkgByIdData.response.externalPackDimW,
                  fuso_externalLength: this.fusoPkgByIdData.response.externalPackDimL,
                  fuso_externalHeight: this.fusoPkgByIdData.response.externalPackDimH,
                  fuso_cubicMeter: this.fusoPkgByIdData.response.externalCubicMeter,
                  fuso_isFoldable: this.fusoPkgByIdData.response.isFoldable,
                  fuso_foldableWidth: this.fusoPkgByIdData.response.foldablePackDimW,
                  fuso_foldableLength: this.fusoPkgByIdData.response.foldablePackDimL,
                  fuso_foldableHeight: this.fusoPkgByIdData.response.foldablePackDimH,
                  fuso_foldableVolume: this.fusoPkgByIdData.response.foldableVolume,
                  fuso_tareWeight: this.fusoPkgByIdData.response.packageTareWeight,
                  fuso_loadCapacity: this.fusoPkgByIdData.response.permittedLoadCapacity,
                  fuso_packageMaterial: this.fusoPkgByIdData.response.packageMaterial,
                  fuso_containerType: this.fusoPkgByIdData.response.containerType
                });
                //this.spinner.hide()
                this.isLoading=false;
              });
          }

          // Only to patch repacking value
          if (this.packageInfoResult != null) {
            if (this.packageInfoResult.response.rePackaging != null) {
              this.packageInfoForm.patchValue({
                repackaging: this.packageInfoResult.response.rePackaging
              });
            }
          }


          if (this.packageInfoResult != null) {
            // this.spinner.show();
            this.packageInfoForm.patchValue({
              fuso_packagingCode: this.packageInfoResult.response.fusoPackageCode,
              fuso_partsInBox: this.packageInfoResult.response.fusoPartsInBox,
              fuso_setPackage: this.packageInfoResult.response.fusoSetsPerPackage,
              fuso_partsPerSet: this.packageInfoResult.response.fusoPartsPerSet,
              fuso_returnable: this.packageInfoResult.response.fusoReturnable,
              fuso_stackable: this.packageInfoResult.response.fusoStackable,
              //fuso_lotsSize: this.packageInfoResult.response.fusoLotSize,
              fuso_stackQty: this.packageInfoResult.response.fusoMaxStackQuantity,
              fuso_packGroupId: this.packageInfoResult.response.fusoMaxPackGroupId,

              returnable: this.packageInfoResult.response.returnable,
              stackQty: this.packageInfoResult.response.maxStackQuantity,
              partsInBox: this.packageInfoResult.response.partsInBox,
              stackable: this.packageInfoResult.response.stackable,
              packGroupId: this.packageInfoResult.response.maxPackGroupId,
              setPackage: this.packageInfoResult.response.setsPerPackage,
              //lotsSize: this.packageInfoResult.response.lotSize,
              partsPerSet: this.packageInfoResult.response.partsPerSet,
              totalBoxWeight: this.packageInfoResult.response.totalMaxWeightBox,
              totalFusoBoxWeight: this.packageInfoResult.response.fusoTotalMaxWeightBox,
              rust: this.packageInfoResult.response.rest,
              interference: this.packageInfoResult.response.interference,
              cleanliness: this.packageInfoResult.response.cleanline

            });
            // this.spinner.hide()
          }

          // if (this.packageInfoResult.response.packageCode) {
          //   this.logbaseService.getPackageById(this.packageInfoResult.response.packageCode)
          //     .subscribe(
          //     result => {
          //       this.pkgByIdData = result;
          //       // Patch the value from response to form field input
          //       this.packageInfoForm.patchValue({
          //         packagingCode: this.pkgByIdData.packageCode,
          //         standardPackage: this.pkgByIdData.standardPackaging,
          //         specializedPackage: this.pkgByIdData.specializedPackaging,
          //         packagingName: this.pkgByIdData.packagingName,
          //         packagingProperty: this.pkgByIdData.packagingProperty,
          //         totalBoxWeight: this.pkgByIdData.totalMaxWeightBox,
          //         innerWidth: this.pkgByIdData.innerPackDimW,
          //         innerLength: this.pkgByIdData.innerPackDimL,
          //         innerHeight: this.pkgByIdData.innerPackDimH,
          //         innerVolume: this.pkgByIdData.innerVolume,
          //         externalWidth: this.pkgByIdData.externalPackDimW,
          //         externalLength: this.pkgByIdData.externalPackDimL,
          //         externalHeight: this.pkgByIdData.externalPackDimH,
          //         cubicMeter: this.pkgByIdData.externalCubicMeter,
          //         isFoldable: this.pkgByIdData.isFoldable,
          //         foldableWidth: this.pkgByIdData.foldablePackDimW,
          //         foldableLength: this.pkgByIdData.foldablePackDimL,
          //         foldableHeight: this.pkgByIdData.foldablePackDimH,
          //         foldableVolume: this.pkgByIdData.foldableVolume,
          //         tareWeight: this.pkgByIdData.packageTareWeight,
          //         loadCapacity: this.pkgByIdData.permittedLoadCapacity,
          //         packageMaterial: this.pkgByIdData.packageMaterial,
          //         containerType: this.pkgByIdData.containerType
          //       });
          //     })
          // }
        });

    //this.spinner.hide();

  };

  // @HostListener("window:beforeunload", ["$event"])
  // public beforeunloadHandler($event) {
  //   $event.returnValue = "Are you sure?";
  //   this.packageID = localStorage.getItem('packageID')
  //   if (confirm("Are you sure you want to leave this page?")) {
  //     return true;
  //   } else {
  //     this.lockUnlockPackage(this.packageID);
  //     return false;
  //   }
  // }

  disableCheck(partData) {

    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let loggedinSuppCode = userDetJson.supplierCode;
    let loggedinLineNo = userDetJson.lineNumbers;
    let loggedInopMgrSupplierCode=userDetJson.operationManagerSupplierCode;
    let loggedInopMgrDeliveryPoint=userDetJson.operationManagerdeliveryPointMaster;

    if (this.userRoleId == 4) {
      if (loggedinLineNo != null) {
        var findLineNo = loggedinLineNo.find(x => x == this.partData.lineNumber);
        var findOMSupCode=loggedInopMgrSupplierCode.find(x=>x==this.partData.supplierCode);
        var findOMDelPoint=loggedInopMgrDeliveryPoint.find(x=>x==this.partData.deliveryPoint);
      }
      findSuppCode = '';
    } else {
      if (loggedinSuppCode != null) {
        var findSuppCode = loggedinSuppCode.find(x => x == this.partData.supplierCode);
      }
      findLineNo = '';
    }

    if (findSuppCode == undefined) {
      this.packageInfoForm.disable();
      this.disableSubmit = true;
    } else if (findLineNo == undefined && findOMDelPoint==undefined) {
      this.packageInfoForm.disable();
      this.disableSubmit = true;
    } else {
      if (this.userRoleId == 5) {
        this.packageInfoForm.disable();
        this.disableSubmit = true;
        this.AdminDisableBtn = true;
      }
      if (this.userRoleId == 1) {
        if (this.overAllPackageIDStatus == 'approvedAndClosed' || this.overAllPackageIDStatus == 'rejectedAndClosed' || this.overAllPackageIDStatus == 'underReview') {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 2) {
        if (this.overAllPackageIDStatus == 'new' || this.overAllPackageIDStatus == 'inProgress' || this.overAllPackageIDStatus != 'underReview' || this.overAllPackageIDStatus == 'underReview' && (partData.supplierManagerStatus == 'approved' || partData.supplierManagerStatus == 'rejected')) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 3) {
        if (this.overAllPackageIDStatus == 'new' || this.overAllPackageIDStatus == 'inProgress' || this.overAllPackageIDStatus != 'underReview' || this.overAllPackageIDStatus == 'underReview' && (partData.logisticStatus == 'approved' || partData.logisticStatus == 'rejected')) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 4) {
        if (this.overAllPackageIDStatus == 'new' || this.overAllPackageIDStatus == 'inProgress' || this.overAllPackageIDStatus != 'underReview' || this.overAllPackageIDStatus == 'underReview' && (partData.operatorStatus == 'approved' || partData.operatorStatus == 'rejected')) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 7) {
        if (this.overAllPackageIDStatus == 'new' || this.overAllPackageIDStatus == 'inProgress' || this.overAllPackageIDStatus != 'underReview' || this.overAllPackageIDStatus == 'underReview' && (partData.supplierManagerVSStatus == 'approved' || partData.supplierManagerVSStatus == 'rejected')) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 9) {
        if (
          this.overAllPackageIDStatus == "approved" ||
          this.overAllPackageIDStatus == "rejected") {
          this.disableSubmit = true;
        }
      }
    }
    if (this.userRoleId == 15) {
      this.AdminDisableBtn = true;

    }
  };

  checkFieldAccess() {

    if (this.userRoleId == 1) {
      this.packagingCodeEdit = true;
      this.standardPackagingEdit = true;
      this.specializedPackagingEdit = true;
      this.repackagingLocationEdit = true;
      this.packagingProperty = true;
      this.packagingNameEdit = true;
      this.innerWidthEdit = true;
      this.innerLengthEdit = true;
      this.innerHeightEdit = true;
      this.externalWidthEdit = true;
      this.externalLengthEdit = true;
      this.externalHeightEdit = true;
      this.FoldableEdit = true;
      this.FoldableWidthEdit = true;
      this.FoldableLengthEdit = true;
      this.FoldableHeightEdit = true;
      this.returnableEdit = true;
      this.stackableEdit = true;
      this.maxStackQtyEdit = true;
      this.packGrpIdEdit = true;
      this.tareWeightEdit = true;
      this.permittedCapacityEdit = true;
      this.packagingMaterialEdit = true;
      this.containerTypeEdit = true;
      this.maxBoxQtyEdit = true;
      this.setsPerPkgEdit = true;
      this.partsPerSetEdit = true;
      this.maxBoxWeightEdit = true;
      this.rustEdit = true;
      this.interferenceEdit = true;
      this.cleanlinessEdit = true;
    } else if (this.userRoleId == 2 || this.userRoleId == 7) {
      this.packagingCodeEdit = false;
      this.standardPackagingEdit = false;
      this.specializedPackagingEdit = false;
      this.repackagingLocationEdit = true;
      this.packagingProperty = false;
      this.packagingNameEdit = false;
      this.innerWidthEdit = false;
      this.innerLengthEdit = false;
      this.innerHeightEdit = false;
      this.externalWidthEdit = false;
      this.externalLengthEdit = false;
      this.externalHeightEdit = false;
      this.FoldableEdit = false;
      this.FoldableWidthEdit = false;
      this.FoldableLengthEdit = false;
      this.FoldableHeightEdit = false;
      this.returnableEdit = false;
      this.stackableEdit = false;
      this.maxStackQtyEdit = false;
      this.packGrpIdEdit = false;
      this.tareWeightEdit = false;
      this.permittedCapacityEdit = false;
      this.packagingMaterialEdit = false;
      this.containerTypeEdit = false;
      this.maxBoxQtyEdit = false;
      this.setsPerPkgEdit = false;
      this.partsPerSetEdit = false;
      this.maxBoxWeightEdit = false;
      this.rustEdit = true;
      this.interferenceEdit = true;
      this.cleanlinessEdit = true;
    } else if (this.userRoleId == 3) {
      this.packagingCodeEdit = true;
      this.standardPackagingEdit = true;
      this.specializedPackagingEdit = true;
      this.repackagingLocationEdit = false;
      this.packagingProperty = false;
      this.packagingNameEdit = true;
      this.innerWidthEdit = true;
      this.innerLengthEdit = true;
      this.innerHeightEdit = true;
      this.externalWidthEdit = true;
      this.externalLengthEdit = true;
      this.externalHeightEdit = true;
      this.FoldableEdit = true;
      this.FoldableWidthEdit = true;
      this.FoldableLengthEdit = true;
      this.FoldableHeightEdit = true;
      this.returnableEdit = true;
      this.stackableEdit = true;
      this.maxStackQtyEdit = true;
      this.packGrpIdEdit = true;
      this.tareWeightEdit = true;
      this.permittedCapacityEdit = true;
      this.packagingMaterialEdit = true;
      this.containerTypeEdit = true;
      this.maxBoxQtyEdit = true;
      this.setsPerPkgEdit = true;
      this.partsPerSetEdit = true;
      this.maxBoxWeightEdit = true;
      this.rustEdit = true;
      this.interferenceEdit = true;
      this.cleanlinessEdit = true;

    } else if (this.userRoleId == 4) {
      this.packagingCodeEdit = false;
      this.standardPackagingEdit = true;
      this.specializedPackagingEdit = false;
      this.repackagingLocationEdit = false;
      this.packagingProperty = true;
      this.packagingNameEdit = false;
      this.innerWidthEdit = false;
      this.innerLengthEdit = false;
      this.innerHeightEdit = false;
      this.externalWidthEdit = false;
      this.externalLengthEdit = false;
      this.externalHeightEdit = false;
      this.FoldableEdit = false;
      this.FoldableWidthEdit = false;
      this.FoldableLengthEdit = false;
      this.FoldableHeightEdit = false;
      this.returnableEdit = false;
      this.stackableEdit = false;
      this.maxStackQtyEdit = false;
      this.packGrpIdEdit = false;
      this.tareWeightEdit = false;
      this.permittedCapacityEdit = false;
      this.packagingMaterialEdit = false;
      this.containerTypeEdit = false;
      this.maxBoxQtyEdit = false;
      this.setsPerPkgEdit = false;
      this.partsPerSetEdit = false;
      this.maxBoxWeightEdit = false;
      this.rustEdit = false;
      this.interferenceEdit = false;
      this.cleanlinessEdit = false;
    }
  }

  stackChange(val: any) {
    const stckVal1: number = 1
    if (val == "No") {
      this.packageInfoForm.patchValue({
        stackQty: stckVal1
      })
      this.packageInfoForm.controls['stackQty'].disable();
    }
    else {
      this.packageInfoForm.patchValue({
        stackQty: ''
      })
      this.packageInfoForm.controls['stackQty'].enable();
    }
  }

  createFormControls() {
    this.packageInfoForm = new FormGroup({
      tareWeight: new FormControl({ value: '', disabled: true }, Validators.required),
      loadCapacity: new FormControl({ value: '', disabled: true }, Validators.required),
      packageMaterial: new FormControl({ value: '', disabled: true }, Validators.required),
      supplierCode: new FormControl({ value: '', disabled: true }),
      partNumber: new FormControl({ value: '', disabled: true }),
      partName: new FormControl({ value: '', disabled: true }),
      supplierName: new FormControl({ value: '', disabled: true }),
      packagingProperty: new FormControl({ value: '', disabled: this.packagingProperty }, Validators.required),
      packagingCode: new FormControl({ value: '', disabled: this.packagingCodeEdit }, [Validators.required, Validators.maxLength(14)]),
      standardPackage: new FormControl({ value: '', disabled: true }, Validators.required),
      specializedPackage: new FormControl({ value: '', disabled: true }, Validators.required),
      packagingName: new FormControl({ value: '', disabled: true }, Validators.maxLength(14)),
      totalBoxWeight: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]),

      totalFusoBoxWeight: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]),
      innerWidth: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      innerLength: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      innerHeight: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      innerVolume: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]),
      externalWidth: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      externalLength: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      externalHeight: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      cubicMeter: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]),
      foldableWidth: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      foldableLength: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      foldableHeight: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]),
      foldableVolume: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]),
      isFoldable: new FormControl({ value: '', disabled: true }),
      returnable: new FormControl({ value: '', disabled: this.returnableEdit }, Validators.required),
      stackQty: new FormControl({ value: '', disabled: this.maxStackQtyEdit }, [Validators.required, Validators.maxLength(2), CustomValidators.isNum]),
      partsInBox: new FormControl({ value: '', disabled: this.maxBoxQtyEdit }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]),
      stackable: new FormControl({ value: '', disabled: this.stackableEdit }, Validators.required),
      packGroupId: new FormControl({ value: '', disabled: this.packGrpIdEdit }, Validators.maxLength(3)),
      setPackage: new FormControl({ value: '', disabled: this.setsPerPkgEdit }),
      //lotsSize: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4), CustomValidators.isNum]),
      containerType: new FormControl({ value: '', disabled: true }),
      partsPerSet: new FormControl({ value: '', disabled: this.partsPerSetEdit }),
      rust: new FormControl({ value: '', disabled: this.rustEdit }, Validators.required),
      interference: new FormControl({ value: '', disabled: this.interferenceEdit }, Validators.required),
      cleanliness: new FormControl({ value: '', disabled: this.cleanlinessEdit }, Validators.required),
      repackaging: new FormControl({ value: 'No', disabled: false })
    });
  }


  showLookupData() {
    this.spinner.show();

    this.modelRef.close();
    this.showLookup = true;
    this.showRegPackage = false;
    if (this.pkgselect != null) {
      this.packageInfoForm.patchValue({
        packagingCode: this.pkgselect.packageCode,
        standardPackage: this.pkgselect.standardPackaging,
        specializedPackage: this.pkgselect.specializedPackaging,
        packagingName: this.pkgselect.packagingName,
        //totalBoxWeight: this.pkgselect.totalMaxWeightBox,
        innerWidth: this.pkgselect.innerPackDimW,
        innerLength: this.pkgselect.innerPackDimL,
        innerHeight: this.pkgselect.innerPackDimH,
        innerVolume: this.pkgselect.innerVolume,
        externalWidth: this.pkgselect.externalPackDimW,
        externalLength: this.pkgselect.externalPackDimL,
        externalHeight: this.pkgselect.externalPackDimH,
        cubicMeter: this.pkgselect.externalCubicMeter,
        isFoldable: this.pkgselect.isFoldable,
        foldableWidth: this.pkgselect.foldablePackDimW,
        foldableLength: this.pkgselect.foldablePackDimL,
        foldableHeight: this.pkgselect.foldablePackDimH,
        foldableVolume: this.pkgselect.foldableVolume,
        tareWeight: this.pkgselect.packageTareWeight,
        loadCapacity: this.pkgselect.permittedLoadCapacity,
        packageMaterial: this.pkgselect.packageMaterial,
        containerType: this.pkgselect.containerType
      });
    }
    this.spinner.hide();

  };

  showLookupFusoData() {
    //this.spinner.show();

    this.modelRef.close();
    if (this.fusoPkgselect != null) {
      this.packageInfoForm.patchValue({
        fuso_packagingCode: this.fusoPkgselect.fusoPackageCode,
        fuso_standardPackage: this.fusoPkgselect.standardPackaging,
        fuso_specializedPackage: this.fusoPkgselect.specializedPackaging,
        fuso_packagingName: this.fusoPkgselect.packagingName,
        fuso_totalBoxWeight: this.fusoPkgselect.totalMaxWeightBox,
        fuso_innerWidth: this.fusoPkgselect.innerPackDimW,
        fuso_innerLength: this.fusoPkgselect.innerPackDimL,
        fuso_innerHeight: this.fusoPkgselect.innerPackDimH,
        fuso_innerVolume: this.fusoPkgselect.innerVolume,
        fuso_externalWidth: this.fusoPkgselect.externalPackDimW,
        fuso_externalLength: this.fusoPkgselect.externalPackDimL,
        fuso_externalHeight: this.fusoPkgselect.externalPackDimH,
        fuso_cubicMeter: this.fusoPkgselect.externalCubicMeter,
        fuso_isFoldable: this.fusoPkgselect.isFoldable,
        fuso_foldableWidth: this.fusoPkgselect.foldablePackDimW,
        fuso_foldableLength: this.fusoPkgselect.foldablePackDimL,
        fuso_foldableHeight: this.fusoPkgselect.foldablePackDimH,
        fuso_foldableVolume: this.fusoPkgselect.foldableVolume,
        fuso_tareWeight: this.fusoPkgselect.packageTareWeight,
        fuso_loadCapacity: this.fusoPkgselect.permittedLoadCapacity,
        fuso_packageMaterial: this.fusoPkgselect.packageMaterial,
        fuso_containerType: this.fusoPkgselect.containerType
      });
    }
    this.spinner.hide();

  };

  savePkgInfo(changeStatus, imagesUp) {
   // this.validate=false;

    //this.spinner.show();

    // To retain the old images uploaded
    let saveImg = [];
    if (imagesUp == null || imagesUp == '') {
      if (this.pkgImageDetails) {
        this.pkgImageDetails.forEach(function (value, key) {
          saveImg.push({"imageId": value.imageId, "imageName": value.imageName, "imageUri": value.imageUri, "isMasterDataSheet": value.isMasterDataSheet });
        });
      };
      imagesUp = saveImg;
    };

    let formDataToSend;
    if (this.userRoleId == 4) {
      formDataToSend = {
        packageId: this.routePackageID,
        packagingProperty: this.packageInfoForm.get('packagingProperty').value,
        rest: this.packageInfoForm.get('rust').value,
        interference: this.packageInfoForm.get('interference').value,
        cleanline: this.packageInfoForm.get('cleanliness').value,
        masterDataSheet: '',
        packageCode: this.packageInfoForm.get('packagingCode').value,
        partsInBox: this.packageInfoForm.get('partsInBox').value,
        setsPerPackage: this.packageInfoForm.get('setPackage').value,
        partsPerSet: this.packageInfoForm.get('partsPerSet').value,
        returnable: this.packageInfoForm.get('returnable').value,
        stackable: this.packageInfoForm.get('stackable').value,
        //lotSize: this.packageInfoForm.get('lotsSize').value,
        maxStackQuantity: this.packageInfoForm.get('stackQty').value,
        maxPackGroupId: this.packageInfoForm.get('packGroupId').value,
        imageInfos: imagesUp,

        rePackaging: this.packageInfoForm.get('repackaging').value,
        fusoPackageCode: this.packageInfoForm.get('fuso_packagingCode').value,
        fusoPartsInBox: this.packageInfoForm.get('fuso_partsInBox').value,
        fusoSetsPerPackage: this.packageInfoForm.get('fuso_setPackage').value,
        fusoPartsPerSet: this.packageInfoForm.get('fuso_partsPerSet').value,
        fusoReturnable: this.packageInfoForm.get('fuso_returnable').value,
        fusoStackable: this.packageInfoForm.get('fuso_stackable').value,
        //fusoLotSize: this.packageInfoForm.get('fuso_lotsSize').value,
        fusoMaxStackQuantity: this.packageInfoForm.get('fuso_stackQty').value,
        fusoMaxPackGroupId: this.packageInfoForm.get('fuso_packGroupId').value
      };

    } else {

      formDataToSend = {
        packageId: this.routePackageID,
        packagingProperty: this.packageInfoForm.get('packagingProperty').value,
        rest: this.packageInfoForm.get('rust').value,
        interference: this.packageInfoForm.get('interference').value,
        cleanline: this.packageInfoForm.get('cleanliness').value,
        masterDataSheet: '',
        packageCode: this.packageInfoForm.get('packagingCode').value,
        partsInBox: this.packageInfoForm.get('partsInBox').value,
        setsPerPackage: this.packageInfoForm.get('setPackage').value,
        partsPerSet: this.packageInfoForm.get('partsPerSet').value,
        returnable: this.packageInfoForm.get('returnable').value,
        stackable: this.packageInfoForm.get('stackable').value,
        //lotSize: this.packageInfoForm.get('lotsSize').value,
        maxStackQuantity: this.packageInfoForm.get('stackQty').value,
        maxPackGroupId: this.packageInfoForm.get('packGroupId').value,
        rePackaging: this.packageInfoForm.get('repackaging').value,
        imageInfos: imagesUp,
      };
    };

    this.logbaseService.savePkgFormData(formDataToSend)
      .subscribe(response => { // Success
        // Data copy set to 1 if supply info saved
        let localPartData = localStorage.getItem("copiedPart");
        if (localPartData != 'undefined') {
          let copiedPart = JSON.parse(localPartData);
          if (copiedPart != null) {
            this.copiedPartInfo = {
              currentPart: this.routePackageID,
              copyPart: copiedPart.copyPart,
              partInfoSave: copiedPart.partInfoSave,
              supplyInfoSave: copiedPart.supplyInfoSave,
              pkgInfoSave: 1
            }
          }
        }
        localStorage.setItem("copiedPart", JSON.stringify(this.copiedPartInfo));

        if (changeStatus != 0) {
          this.toastr.success(this.translate.instant('PACK_INFO_SAVED_SUCCESS'));
        }

        // Recall saved information
        this.getPackageInfoById(this.partData);
      });

    // Update status of package from new to inProgress status only by supplier
    if (changeStatus != 0) {
      if (this.partData.ovarAllPackageIDStatus != 'inProgress') {
        if (this.userRoleId == 1 || this.userRoleId == 9) {
          let statusDataToSend = {
            packStatus: 'inProgress',
            packageid: this.partData.packageId,
            updatedBy: this.loginId,
            userRole: this.userRoleId
          }

          this.logbaseService.updatePackageStatus(statusDataToSend)
            .subscribe(response => {
              localStorage.setItem('packageOverallStatus', 'In Progress');
            });
        }
      }
    }
    this.navigateAfterSave = false;
    console.log("in save partserv and supplyinfo data is and package",this.partServData,this.supplyServData,this.packageInfoForm)
    this.spinner.hide();

  }

  showRegPackageData() {
    this.showLookup = false;
    this.showRegPackage = true;
  };

  isSupplierFormValid() {
    let returnType = true

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    if (userDetJson.userRoleMappings[0].roleName == 'Supplier') {
      // userDetJson.userRoleMappings[0].roleName == 'SMVS' || 
      // userDetJson.userRoleMappings[0].roleName == 'SMQ'){

      let temparray = []
      let regex = /^\d{8}$/
      let jpregex = /^\d{3}-\d{4}$/;
      for (let index = 0; index < this.supplyServData.formDataVal.controls.items.controls.length; index++) {
        if (this.supplyServData.formDataVal.controls.items.controls[index].value.supplyCountry != 'Japan' &&
          regex.test(this.supplyServData.formDataVal.controls.items.controls[index].value.supplyJapanZipcode)) {
          temparray.push("true")
        } else if (this.supplyServData.formDataVal.controls.items.controls[index].value.supplyCountry == 'Japan' &&
          jpregex.test(this.supplyServData.formDataVal.controls.items.controls[index].value.supplyJapanZipcode)) {
          temparray.push("true")
        } else {
          temparray.push("false")
        }
      }
      temparray.forEach(function (value, key) {
        if (value == "false") {
          returnType = false
        }
      });
    } else {
      returnType = true
    }
    return returnType
  }

  async openStatusModal(detailPage) {
  
   
    localStorage.removeItem('lookUp');
    this.spinner.show();
    console.log("partsServData and supplyinfodata and packageinfo",this.partServData,this.supplyServData,this.packageInfoForm)
    try
    {
   this.data= await this.waitFor(this.logbaseService.dataStatus(this.routePackageID));
    if(this.data.response.packageDataStatus==false)
        {
          this.validate=true
          this.toastr.warning('There are some missing fields not saved. Please click on Validate Button');
          this.spinner.hide();
          return;
        }

    else if(this.data.response.packageDataStatus==true){
     
          if (this.partServData.formDataVal.valid == true && this.supplyServData.formDataVal.valid == true && this.packageInfoForm.valid == true) {
      
            this.modelRef = this.modalService.open(detailPage, { windowClass: 'detail-modal',backdrop:false });
            this.modelRef.result.then((result) => {
            });
          } else {
            if (this.partServData.formDataVal.valid == false) {
              this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PART_INFO'));
            } else if (this.supplyServData.formDataVal.valid == false) {
              console.log(this.supplyServData.formDataVal,"test")
              this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
            }
            // else if (!this.isSupplierFormValid()) {
            //   this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
            // }
            else if (this.packageInfoForm.valid == false) {
              this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PACKAGE_INFO'));
            }
          }
          this.spinner.hide();
        }
    
    }
    catch(error){
      this.toastr.warning('There are some missing fields not saved. Please click on Validate Button');
      this.validate=true;
      this.spinner.hide();
      return;
    }
    
      // if (this.partServData.formDataVal.valid == true && this.supplyServData.formDataVal.valid == true && this.packageInfoForm.valid == true) {
      
      //   this.modelRef = this.modalService.open(detailPage, { windowClass: 'detail-modal',backdrop:false });
      //   this.modelRef.result.then((result) => {
      //   });
      // } else {
      //   if (this.partServData.formDataVal.valid == false) {
      //     this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PART_INFO'));
      //   } else if (this.supplyServData.formDataVal.valid == false) {
      //     console.log(this.supplyServData.formDataVal,"test")
      //     this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
      //   }
      //   // else if (!this.isSupplierFormValid()) {
      //   //   this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
      //   // }
      //   else if (this.packageInfoForm.valid == false) {
      //     this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PACKAGE_INFO'));
      //   }
      // }
      // this.spinner.hide();
  
    
    
    }

    reValidate(detailPage){

      this.logbaseService.savePartFormData(this.formData).subscribe(response => {
                this.toastr.success("Proceed with Save and submit");
                this.validate=false;
        });
        // this.toastr.success('Part Information Form Saved Successfully!');
        // Call API to get data once after part info form saved
      }
      //save the data
      // this.savePkgInfo(1,null);
      // this.openStatusModal(detailPage)
      //this.router.navigate(['partDetails/partsInfo',this.partData.packageId], { queryParams: { validate: 'true' } }); // Navigate to the other component with query parameter
  
  

 

 

  async waitFor<T>(observable: Observable<T>) {
    return firstValueFrom(observable);
  }

 

  openStatusRevisedModal(detailPage) {
   console.log("in openRevisedModal")
  //  this.logbaseService.dataStatus()
    localStorage.removeItem('lookUp');
    this.spinner.show();
    const invalid = [];
    const controls = this.partServData.formDataVal.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }

    if (this.overAllPackageIDStatus == 'approved') {
      if (this.supplyServData.formDataVal.valid == true && this.packageInfoForm.valid == true) {
        this.modelRef = this.modalService.open(detailPage, { windowClass: 'detail-modal',backdrop:false });
        this.modelRef.result.then((result) => {
        });
      } else {
        if (this.supplyServData.formDataVal.valid == false) {
          this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
        } else if (this.packageInfoForm.valid == false) {
          this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PACKAGE_INFO'));
        }
      }
    } else {
      if (this.partServData.formDataVal.valid == true && this.supplyServData.formDataVal.valid == true && this.packageInfoForm.valid == true) {
        this.modelRef = this.modalService.open(detailPage, { windowClass: 'detail-modal',backdrop:false });
        this.modelRef.result.then((result) => {
        });
      } else {
        if (this.partServData.formDataVal.valid == false) {
          this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PART_INFO'));
        } else if (this.supplyServData.formDataVal.valid == false) {
          this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_SUPPLY_INFO'));
        } else if (this.packageInfoForm.valid == false) {
          this.toastr.warning(this.translate.instant('COMPLETE_ALL_REQUIRED_PACKAGE_INFO'));
        }
      }
    }

    this.spinner.hide();


  };

  onStatusChange(option) {
    this.statusOption = option;
    if (option == 2 || option == 5 || option == 6) {
      this.showStatusComment = true;
    } else if ((option == 1)) {
      this.showStatusComment = false;
    }
  };
  onCheckboxChange(value:any){
    console.log(value)
    this.pkgselect=value
  }

  onCommentEnter() {
    if (this.statusComment == '') {
      this.showStatusError = true;
    } else {
      this.showStatusError = false;
    }
  }

  onrevisedComment() {
    if (this.revisedComment == '') {
      this.revisedCommentError = true;
    } else {
      this.revisedCommentError = false;
    }
  }
  submitPackage(revisedPkg) {
    this.spinner.show();

    if (revisedPkg == null || revisedPkg == undefined) {

      if (this.statusOption == 1 || this.statusOption == 6) {
        this.updateStatusTo = 'approved';
        let statusDataToSend = {
          packStatus: this.updateStatusTo,
          packageid: this.partData.packageId,
          updatedBy: this.loginId,
          userRole: this.userRoleId,
          approvedComments: this.statusComment
        }

        
        this.logbaseService.updatePackageStatus(statusDataToSend)
          .subscribe(response => {
            this.spinner.show();
            // Save Package Info form if user directly submit the package without save
            let changeStatus = 0;
            this.savePkgInfo(changeStatus, null);
            this.toastr.success("Package " + this.updateStatusTo + " successfully!");
            this.modelRef.close();
            localStorage.removeItem('copiedPart');

            this.router.navigate(['/dashboard']);
            localStorage.removeItem('');

            let revisionData = {
              packageId: this.partData.packageId,
              status: "completed"
            }
            this.spinner.show();
            if(this.userRoleId=='1'){
            this.logbaseService.changeRevisionStatus(revisionData).subscribe(
              result => { 
              }
            )
            }
          setTimeout(() => {
            this.spinner.hide();
            
          }, 3000);

          });


      } else if (this.statusOption == 2) {
        this.updateStatusTo = 'rejected';

        if (this.statusComment == '' || this.statusComment == null) {
          this.showStatusError = true;
        } else {
          this.showStatusError = false;
          let statusDataToSend = {
            packStatus: this.updateStatusTo,
            packageid: this.partData.packageId,
            updatedBy: this.loginId,
            userRole: this.userRoleId,
            rejectedComments: this.statusComment
          }

          this.logbaseService.updatePackageStatus(statusDataToSend)
            .subscribe(response => {

              // Save Package Info form if user directly submit the package without save
              let changeStatus = 0;
              this.savePkgInfo(changeStatus, null);
              this.toastr.success("Package " + this.updateStatusTo + " successfully!");
              this.modelRef.close();

              localStorage.removeItem('copiedPart');
              this.router.navigate(['/dashboard']);

            });
        }
      } else if (this.statusOption == 3) {
        this.updateStatusTo = 'rejectedAndClosed';
        this.showStatusError = false;
        let statusDataToSend = {
          packStatus: this.updateStatusTo,
          packageid: this.partData.packageId,
          rejectedComments: null,
          updatedBy: this.loginId,
          userRole: this.userRoleId
        }
        this.logbaseService.updatePackageStatus(statusDataToSend)
          .subscribe(response => {

            // Save Package Info form if user directly submit the package without save
            let changeStatus = 0;
            this.savePkgInfo(changeStatus, null);
            this.toastr.success(this.translate.instant('PKG_REJECT_CLOSED_SUCCESS'));
            this.modelRef.close();
            localStorage.removeItem('copiedPart');

            this.router.navigate(['/dashboard']);

          });
      } else if (this.statusOption == 4) {
        this.updateStatusTo = 'approvedAndClosed';
        this.showStatusError = false;
        let statusDataToSend = {
          packStatus: this.updateStatusTo,
          packageid: this.partData.packageId,
          rejectedComments: null,
          updatedBy: this.loginId,
          userRole: this.userRoleId
        }
        this.logbaseService.updatePackageStatus(statusDataToSend)
          .subscribe(response => {

            // Save Package Info form if user directly submit the package without save
            let changeStatus = 0;
            this.savePkgInfo(changeStatus, null);
            this.toastr.success(this.translate.instant('PKG_APP_CLOSED_SUCCESS'));
            this.modelRef.close();
            localStorage.removeItem('copiedPart');

            this.router.navigate(['/dashboard']);

          });
      } else if (this.statusOption == 5) {
        this.updateStatusTo = 'allApproved';
        this.showStatusError = false;
        let statusDataToSend = {
          packStatus: this.updateStatusTo,
          packageid: this.partData.packageId,
          approvedComments: this.statusComment,
          updatedBy: this.loginId,
          userRole: this.userRoleId
        }
        this.logbaseService.updatePackageStatus(statusDataToSend)
          .subscribe(response => {

            // Save Package Info form if user directly submit the package without save
            let changeStatus = 0;
            this.savePkgInfo(changeStatus, null);
            this.toastr.success(this.translate.instant('PKG_APP_ALL_SUCCESS'));
            this.modelRef.close();
            localStorage.removeItem('copiedPart');

            this.router.navigate(['/dashboard']);

          });
      }
      // To unlock package to edit
      //this.lockUnlockPackage(this.partData.packageId);

    } else {

      // if the part is approved / Approved & Closed
      if (this.revisedComment == '' || this.revisedComment == null) {
        this.revisedCommentError = true;
      } else {
        this.revisedCommentError = false;

        this.updateStatusTo = 'approved';
        let statusDataToSend = {
          packStatus: this.updateStatusTo,
          packageid: this.partData.packageId,
          updatedBy: this.loginId,
          userRole: this.userRoleId,
          rejectedComments: this.revisedComment
        }

        this.logbaseService.updatePackageStatus(statusDataToSend)
          .subscribe(response => {

            // Save Package Info form if user directly submit the package without save
            let changeStatus = 0;
            this.savePkgInfo(changeStatus, null);
            this.toastr.success("Package " + this.updateStatusTo + " successfully!");
            this.modelRef.close();
            localStorage.removeItem('copiedPart');

            // To unlock package to edit
            //this.lockUnlockPackage(this.partData.packageId);

            this.router.navigate(['/dashboard']);

          });

        let revisionData = {
          packageId: this.partData.packageId,
          status: "completed"
        }

        this.logbaseService.changeRevisionStatus(revisionData).subscribe(
          result => { }
        )
      }
    }
    this.navigateAfterSave = false;
    setTimeout(() => {
      this.spinner.hide(); 
    }, 5000);
    //this.spinner.hide();

  }

  // lockUnlockPackage(routePackageID) {
  //   let dataToSend = {
  //     pkgStatus: "ENABLE",
  //     pkgId: routePackageID
  //   }
  //   this.logbaseService.packageLockUnlock(dataToSend).subscribe(result => {
  //   });
  // }

  canDeactivate() {
    if (this.packageInfoForm.dirty && this.navigateAfterSave == true) {
      return this.formDialogService.confirm();
    }
    return true;
  };

  openLookup(lookupModal) {
    this.modelRef = this.modalService.open(lookupModal, { size: 'lg', windowClass: 'detail-modal',backdrop:false });
    this.modelRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }

  openFusoLookup(fusoLookupModal) {
    this.modelRef = this.modalService.open(fusoLookupModal, { size: 'lg', windowClass: 'detail-modal',backdrop:false });
  }

  vLookupNewPkg() {
    this.modelRef.close();
    this.router.navigate(['/packageDashboard/newPackage']);
  }

  vLookupPkgCreate() {
    this.modelRef.close();
    this.router.navigate(['/packageDashboard/newPackage']);
  }

  onRepackChange(option) {
    //this.spinner.show();

    this.repackagingOption = option;
    if (this.repackagingOption == 'Yes') {
      this.showFusoPkg = true;
      this.suppTabActive = false;
      this.packageInfoForm.addControl('fuso_packagingCode', new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(14)]));
      this.packageInfoForm.addControl('fuso_standardPackage', new FormControl({ value: '', disabled: true }, Validators.required));
      this.packageInfoForm.addControl('fuso_specializedPackage', new FormControl({ value: '', disabled: true }, Validators.required));
      this.packageInfoForm.addControl('fuso_packagingName', new FormControl({ value: '', disabled: true }, Validators.maxLength(14)));
      this.packageInfoForm.addControl('fuso_totalBoxWeight', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_innerWidth', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_innerLength', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_innerHeight', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_innerVolume', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_externalWidth', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_externalLength', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_externalHeight', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_cubicMeter', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_foldableWidth', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_foldableLength', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_foldableHeight', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(6), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_foldableVolume', new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_isFoldable', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_returnable', new FormControl({ value: '', disabled: false }, Validators.required));
      this.packageInfoForm.addControl('fuso_stackQty', new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(2), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_loadCapacity', new FormControl({ value: '', disabled: true }, Validators.required));
      this.packageInfoForm.addControl('fuso_partsInBox', new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_stackable', new FormControl({ value: '', disabled: false }, Validators.required));
      this.packageInfoForm.addControl('fuso_packGroupId', new FormControl({ value: '', disabled: false }, Validators.maxLength(3)));
      this.packageInfoForm.addControl('fuso_packageMaterial', new FormControl({ value: '', disabled: true }, Validators.required));
      this.packageInfoForm.addControl('fuso_setPackage', new FormControl({ value: '', disabled: false }));
      //this.packageInfoForm.addControl('fuso_lotsSize', new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4), CustomValidators.isNum]));
      this.packageInfoForm.addControl('fuso_tareWeight', new FormControl({ value: '', disabled: true }, Validators.required));
      this.packageInfoForm.addControl('fuso_containerType', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_partsPerSet', new FormControl({ value: '', disabled: false }));
    } else {
      this.showFusoPkg = false;
      this.suppTabActive = true;
      this.packageInfoForm.addControl('fuso_packagingCode', new FormControl({ value: '', disabled: false }));
      // this.packageInfoForm.removeControl('fuso_packagingCode');
      this.packageInfoForm.addControl('fuso_standardPackage', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_specializedPackage', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_packagingName', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_totalBoxWeight', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_innerWidth', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_innerLength', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_innerHeight', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_innerVolume', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_externalWidth', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_externalLength', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_externalHeight', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_cubicMeter', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_foldableWidth', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_foldableLength', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_foldableHeight', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_foldableVolume', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_isFoldable', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_returnable', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_stackQty', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_loadCapacity', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_partsInBox', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_stackable', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_packGroupId', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_packageMaterial', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_setPackage', new FormControl({ value: '', disabled: false }));
      //this.packageInfoForm.addControl('fuso_lotsSize', new FormControl({ value: '', disabled: false }));
      this.packageInfoForm.addControl('fuso_tareWeight', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_containerType', new FormControl({ value: '', disabled: true }));
      this.packageInfoForm.addControl('fuso_partsPerSet', new FormControl({ value: '', disabled: false }));

    }
    this.spinner.hide();

  }

  uploadMasterData(event, form) {
    this.masterUploadProgress = false;
    this.isDuplicationMasterFilename = false;
    let isUniqueFile;
    let imagesUp = [];
    const formdata = new FormData();
    if (this.pkgImageDetails) {
      this.pkgImageDetails.forEach(function (value, key) {

        for (let i = 0; i < event.files.length; i++) {
          if (event.files[i].name == value.imageName) {
            isUniqueFile = true;
            form.clear();
          } else {
            imagesUp.push({ "imageId": value.imageId, "imageName": value.imageName, "imageUri": value.imageUri, "isMasterDataSheet": value.isMasterDataSheet });
          };
        }
      });
    }

    this.isDuplicationMasterFilename = isUniqueFile
    if (!this.isDuplicationMasterFilename) {
      event.files.forEach(function (value, key) {
        formdata.append('imageFiles', value);
        // Loop on image uploaded
        imagesUp.push({ "imageName": value.name, "isMasterDataSheet": "true" });
      });

      this.savePkgInfo(0, imagesUp);
      setTimeout(() => {
        this.spinner.show();
        this.logbaseService.masterDataUpload(formdata, this.routePackageID)
          .subscribe(response => {
            if (response.status.statusCode == 1) {
              this.translate.get("Master Data Sheet Uploaded successfully!").subscribe((res: string) => {
                this.toastr.success(res);
              });

              // To update part into inProgress status after image upload
              if (this.partData.ovarAllPackageIDStatus == 'new') {
                let statusDataToSend = {
                  packStatus: 'inProgress',
                  packageid: this.partData.packageId,
                  updatedBy: this.loginId,
                  userRole: this.userRoleId
                };
                this.logbaseService.updatePackageStatus(statusDataToSend)
                  .subscribe(response => {
                    //localStorage.setItem('packageOverallStatus', 'In Progress');
                    this.displayOverallStatus = 'In Progress';
                  });
              }
            };

            form.clear();
            this.spinner.hide();
            // Call API to get data once after image deleted
            this.getPackageInfoById(this.partData);
          },
            err => {
              this.toastr.error("Upload failed, Max file size should not exceed 10MB. Please try again!");
              this.masterUploadProgress = false;
              this.spinner.hide();
            });

      }, 1000);
    }

  }

  uploadPackageImg(event, form) {
    this.pkgimgUploadProgress = true;
    this.isDuplicationpackageFilename = false
    let isUniqueFile
    let imagesUp = [];
    const formdata = new FormData();
    if (this.pkgImageDetails) {
      this.pkgImageDetails.forEach(function (value, key) {
        for (let i = 0; i < event.files.length; i++) {
          if (event.files[i].name == value.imageName) {
            isUniqueFile = true;
            form.clear();
          } else {
            imagesUp.push({ "imageId": value.imageId, "imageName": value.imageName, "imageUri": value.imageUri, "isMasterDataSheet": value.isMasterDataSheet });
          };
        }
      });
    };

    this.isDuplicationpackageFilename = isUniqueFile
    if (!this.isDuplicationpackageFilename) {
      event.files.forEach(function (value, key) {
        formdata.append('imageFiles', value);
        // Loop on image uploaded
        imagesUp.push({ "imageName": value.name });
      });

      this.savePkgInfo(0, imagesUp);
      setTimeout(() => {
        this.spinner.show();
        this.logbaseService.masterDataUpload(formdata, this.routePackageID)
          .subscribe(response => {
            if (response.status.statusCode == 1) {
              this.translate.get('IMG_UPLOAD_SUCCESS').subscribe((res: string) => {
                this.toastr.success(res);
              });

              // To update part into inProgress status after image upload
              if (this.partData.ovarAllPackageIDStatus == 'new') {
                let statusDataToSend = {
                  packStatus: 'inProgress',
                  packageid: this.partData.packageId,
                  updatedBy: this.loginId,
                  userRole: this.userRoleId
                };
                this.logbaseService.updatePackageStatus(statusDataToSend)
                  .subscribe(response => {
                    this.displayOverallStatus = 'In Progress';
                    //localStorage.setItem('overAllPackageIDStatus', 'inProgress');
                  });
              };
            }
            form.clear();
            this.spinner.hide();
            // Call API to get data once after image deleted
            this.getPackageInfoById(this.partData);
          }),
          err => {
            this.toastr.error("Upload failed, Max file size should not exceed 10MB. Please try again!");
            this.pkgimgUploadProgress = false;
            this.spinner.hide();
          };
      }, 1000);
    }
  }

  openImgDelCfm(imgToDel, imgdelModal) {
    this.modelRef = this.modalService.open(imgdelModal, {backdrop:false});
    this.imgToDelete = imgToDel;
  };

  deletePartImg() {
    //this.spinner.show();

    this.modelRef.close();
    let dataToSend;

    if (this.imgToDelete.isMasterDataSheet == true) {
      dataToSend = [
        {
          "imageId": this.imgToDelete.imageId,
          "imageName": this.imgToDelete.imageName,
          "imageUri": this.imgToDelete.imageUri,
          "imageTitle": this.imgToDelete.imageTitle,
          "isMasterDataSheet": "true"
        }
      ]
    } else {
      dataToSend = [
        {
          "imageId": this.imgToDelete.imageId,
          "imageName": this.imgToDelete.imageName,
          "imageUri": this.imgToDelete.imageUri,
          "imageTitle": this.imgToDelete.imageTitle,
          "isMasterDataSheet": "false"
        }
      ]
    }

    this.logbaseService.deletePackageImage(dataToSend, this.routePackageID)
      .subscribe(
        result => {
          this.translate.get('deleted Successfully').subscribe((res: string) => {
            this.toastr.success('' + this.imgToDelete.imageName + ' ' + res);
          });
          // Call API to get data once after image deleted
          this.getPackageInfoById(this.partData);
        });

    this.spinner.hide();

  };

}
